import React from "react";
import Creatable from 'react-select/creatable';

const CreatableSelector = (props) => {
    const { options, placeholder, onSelect, values, headerView, disableMulti } = props
    return (
        <div className='mt-3'>
            { headerView }
            <div className='col-md-12'>
                <Creatable
                    value={ values }
                    onChange={ onSelect }
                    isSearchable={ true }
                    placeholder={ placeholder }
                    options={ options }
                    isMulti={ !disableMulti }
                    isClearable
                />
            </div>
        </div>
    )
}

export default CreatableSelector
